/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag } from "../unleash";

const FcsPermission = {
  permission_rtc_seamless_scan_flag_v4_enable: new FcsFlag.Flag(false),
  permission_rtc_seamless_booking_v4_enable: new FcsFlag.Flag(false)
}

export const FlagRtcSeamless = {
  ...FcsPermission
}

export const initFlagsRtcSeamless = () => {
  FcsFlag.register("featureRtcSeamless", FlagRtcSeamless)
}

